import { PATHS } from "../paths";

export const excludePresidentCardPath: string[] = [
  PATHS.SETTINGS_IDENTIFICATION,
  PATHS.SETTINGS_SLACK_NOTIFICATION,
  PATHS.SETTINGS_TEAMS_NOTIFICATION,
  PATHS.SETTINGS_SSO,
]
